import { GsapAnimation } from '../gsap/_gsap';
import { wrapCharSpan } from './_wrapCharSpan';
import { smoothScroll } from './_smoothScroll';

const gsap = new GsapAnimation();

export const loadingPage = () => {
  /**
   * h1タイトルのアニメーション
   */
  window.addEventListener('load', function () {
    // 画面スクロールを無効にする
    const body = document.querySelector('html body');
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';

    // h1タイトルのアニメーション
    const fvTitle = document.querySelector('.p-page-fv__heading .gsap-textSplit');
    fvTitle.innerHTML = wrapCharSpan(fvTitle.textContent);
    this.setTimeout(function () {
      gsap.textSplit(fvTitle);
    }, 500);

    this.setTimeout(function () {
      // 黒い帯を動かす
      document.querySelectorAll('.js-mvCurtainInner > div').forEach(function (item) {
        item.classList.add('is--animate');
      });
    }, 1000);

    // 画像を少しずつ縮小させる
    const fvImg = document.querySelector('.p-page-fv__img-inner');
    if (fvImg !== null) {
      this.setTimeout(function () {
        fvImg.classList.add('is--scaleOut');
      }, 200);
    }

    // ヘッダーの出現
    this.setTimeout(function () {
      // 1秒後、ヘッダーに is--loadクラスを付与（ロゴ等のフェードインの為）
      const header = document.querySelector('.l-header');
      header.classList.add('is--load');
    }, 1000);

    this.setTimeout(function () {
      // 1秒後、画面スクロールを有効する
      body.style.position = 'static';
      body.style.overflow = 'visible';
    }, 1000);

    if (!location.hash) return;

    this.setTimeout(function () {
      smoothScroll(location.hash);
    }, 2600);
  });
};
